import React from 'react';
export const TimelineListItemDateText = (props) => {
    const { nameText, dateText } = props;
    return (React.createElement("div", { style: {
            color: '#00000099',
            fontFamily: 'Barlow',
            fontWeight: '400',
            fontSize: '12px'
        } },
        nameText,
        " \u2022 ",
        dateText));
};
